import classNames from "classnames";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthHeader from "src/components/@auth/auth-layout/auth-header";
import { EyeClosedIcon, EyeIcon } from "src/components/icons";
import PrimaryButton from "src/components/reusable/button/primary-button";
import AppFooter from "src/layouts/footer";

const PASSWORD = "perceiveAI@2025"; // Replace with your desired password

const DropboxLogin = () => {
  const [inputPassword, setInputPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleLogin = () => {
    if (inputPassword === PASSWORD) {
      localStorage.setItem("dropboxAccess", "granted");
      navigate("/dropbox", { replace: true });
    } else {
      setError("Incorrect password. Please try again.");
    }
  };

  return (
    <>
      <AuthHeader />
      <div className="h-full min-h-[calc(100vh-90px)] flex items-center justify-center bg-gray-100">
        <div className="w-full md:w-[400px]">
          <h1 className="text-4xl font-extrabold text-secondary-800 ">Sign In to Dropbox</h1>
          <fieldset className="mt-3">
            <div className="mt-0.5 rounded-md shadow-sm relative">
              <input
                id="password"
                type={isPasswordVisible ? "text" : "password"}
                value={inputPassword}
                onChange={(e) => setInputPassword(e.target.value)}
                placeholder="Enter Password"
                className={classNames(
                  "appearance-none block w-full px-2 py-[10px] border-[1px] border-[#87888C] rounded-full placeholder:text-gray-400 focus:ring-0.5",
                  "border-gray-400 focus:border-primary-500 focus:ring-primary-500",
                )}
              />
              {inputPassword && (
                <div
                  className="absolute top-0 right-2 h-full flex items-center text-gray-600 cursor-pointer"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                >
                  {isPasswordVisible ? <EyeClosedIcon /> : <EyeIcon />}
                </div>
              )}
            </div>
          </fieldset>

          {error && <p className="text-red-600 text-sm mb-2">{error}</p>}
          <div className="flex justify-center w-full mt-3">
            {/* <Button
            classname="w-full"
            htmlType="submit"
            disabled={isSubmitting || isGoogleSubmitting}
            loading={isSubmitting}
            type="primary"
            rounded="full"
          >
            Sign In
          </Button> */}
            <PrimaryButton className="w-full" type="button" onClick={handleLogin} text="Sign In" />
          </div>
        </div>
      </div>
      <AppFooter />
    </>
  );
};

export default DropboxLogin;
